import { useTranslation } from 'next-i18next'
import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { selectTutorForSelfCart, setBookingForSelfFormErrorActionCreator } from '~/redux/slices/cart'

export default function useCheckBookingForSelfFormError(): {
  isFormValid: () => boolean
} {
  const { t } = useTranslation('booking')
  const dispatch = useAppDispatch()
  const cart = useAppSelector(selectTutorForSelfCart)

  useEffect(() => {
    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'location',
        message: undefined,
      }),
    )

    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'product',
        message: undefined,
      }),
    )

    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'levelsOfEducation',
        message: undefined,
      }),
    )

    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'language',
        message: undefined,
      }),
    )

    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'subjects',
        message: undefined,
      }),
    )
  }, [dispatch])

  const isFormValid = (): boolean => {
    let isValid = true

    if (typeof cart.language !== 'string' || !cart.language) {
      dispatch(
        setBookingForSelfFormErrorActionCreator({
          fieldName: 'language',
          message: t('errors.language'),
        }),
      )

      isValid = false
    }

    if (typeof cart.location !== 'string' || !cart.location) {
      dispatch(
        setBookingForSelfFormErrorActionCreator({
          fieldName: 'location',
          message: t('errors.location'),
        }),
      )

      isValid = false
    }

    if (typeof cart.product?.id !== 'number' || !cart.product?.id) {
      dispatch(
        setBookingForSelfFormErrorActionCreator({
          fieldName: 'product',
          message: t('errors.product'),
        }),
      )

      isValid = false
    }

    if (!cart.levelsOfEducation.length) {
      dispatch(
        setBookingForSelfFormErrorActionCreator({
          fieldName: 'levelsOfEducation',
          message: t('errors.levelsOfEducation'),
        }),
      )

      isValid = false
    }
    if (!cart.subjects.length) {
      dispatch(
        setBookingForSelfFormErrorActionCreator({
          fieldName: 'subjects',
          message: t('errors.subjects'),
        }),
      )

      isValid = false
    }

    return isValid
  }

  return { isFormValid }
}
